import { render, staticRenderFns } from "./FulfillmentExport.vue?vue&type=template&id=8a3a7670&scoped=true"
import script from "./FulfillmentExport.vue?vue&type=script&lang=js"
export * from "./FulfillmentExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3a7670",
  null
  
)

export default component.exports